import { useModal } from "@/contexts";
import { BookModalContent } from "@/domains/components";
import { MEDIA } from "@/styles/common";
import { Box } from "@chakra-ui/react";
import { CustomTag } from "./thumbnail.style";
import { type ThumbnailProps } from "./thumbnail.type";

export const Thumbnail = ({ amountOfImgs, imgUrl, isAvailableBook, roomIdx, roomName }: ThumbnailProps) => {
    const { setModalContent, openModal, setIconName } = useModal();

    const onModal = () => {
        setModalContent(<BookModalContent roomIdx={roomIdx} roomName={roomName} />);
        setIconName("close");
        openModal();
    };

    const { isTablet } = MEDIA();

    return (
        <Box
            position="relative"
            cursor="pointer"
            _hover={{ opacity: 0.5 }}
            w={isTablet ? "100%" : "224px"}
            h="184px"
            borderRadius="8px"
            overflow="hidden"
            background={`url(${imgUrl}) no-repeat center/cover`}
            onClick={onModal}
        >
            <CustomTag.Available p="4px 8px" isAvailableBook={isAvailableBook}>
                {isAvailableBook ? "예약 가능" : "예약 마감"}
            </CustomTag.Available>
            <CustomTag.AmountOfImg p="4px 8px" columnGap="4px">
                <span className="material-icons-outlined">photo</span>
                <p>+{amountOfImgs}</p>
            </CustomTag.AmountOfImg>
        </Box>
    );
};
